import { BookingSettingsResponseDTO, GetCompanyPublicInfoResponseDTOV2 } from '@paymash/sdk/api/lib/dto';
import { Injectable } from '@angular/core';
import { Company } from '@modules/core/models/company';
import { BookingSettings } from '@modules/core/models/company/booking-settings';
import { ItemThan } from '@modules/core/models/company/item-than';

@Injectable({
  providedIn: 'root',
})
export class CompanyMapper {
  public mapToEntity(dto: GetCompanyPublicInfoResponseDTOV2): Company {
    return {
      uuid: dto.uuid,
      name: dto.name,
      email: dto.email,
      homepage: dto.homepage,
      description: dto.description,
      locale: dto.locale,
      themeName: dto.themeName,
      image: dto.logo,
      allowUnpaidOrders: dto.allowUnpaidOrders,
      address: {
        country: dto.address?.country?.alpha2 || '',
        phoneNrMobile: dto.address.phoneNrMobile
      },
      paymentProvider: dto.paymentProvider,
      socialMediaFacebook: dto.socialMedia.facebook,
      socialMediaInstagram: dto.socialMedia.instagram,
      socialMediaTwitter: dto.socialMedia.twitter,
      bookingEnabled: dto.featuresEnabled.includes('BOOKING'),
      selfOrderingEnabled: dto.featuresEnabled.includes('SELF_ORDERING'),
      isWebShopEnabled: dto.featuresEnabled.includes('WEBSHOP'),
      bookingSettings: this.mapBookingSettings(dto.bookingSettings),
      companyHomepage: dto.homepage,
      webShopUrl: dto.webShopUrl,
    };
  }

  private mapBookingSettings(bookingSettings: BookingSettingsResponseDTO): BookingSettings {
    return {
      calendarAccuracy: bookingSettings.calendarAccuracy,
      servicesPerBooking: bookingSettings.servicesPerBooking,
      showOnlyBookableHours: bookingSettings.showOnlyBookableHours,
      timeIntervals: bookingSettings.timeIntervals,
      reminderFrequencyOfNotification: bookingSettings.reminderFrequencyOfNotification,
      cancellationPolicy: bookingSettings.cancellationPolicy as ItemThan,
      notEarlyThan: bookingSettings.notEarlyThan as ItemThan,
      notLaterThan: bookingSettings.notLaterThan as ItemThan,
      stores: bookingSettings.stores as never,
    };
  }
}
